<template>
  <ConsentBanner
    v-if="showBanner"
    @acknowledge="onAcknowledge"
  />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ConsentBanner from '@/components/consent/ConsentBanner.vue';
import { hasConsentDecision, acknowledgeConsent, initConsentStorage } from '@/utils/consentManager';
import { isConsentUiEnabled } from '@/constants/consent';

const showBanner = ref(false);

onMounted(async () => {
  if (!isConsentUiEnabled()) return;

  await initConsentStorage();
  showBanner.value = !hasConsentDecision();
});

const onAcknowledge = async () => {
  await acknowledgeConsent();
  showBanner.value = false;
};
</script>
